import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { useGetClickHandlers } from '../DocFlowProfileHeaderActions.hooks'

function RestoreButton({
  className,
  text = 'DocFlow.ProfileRestoreBtnKey',
  ...restProps
}) {
  const { t } = useTranslation()

  const { handleClickRestore } = useGetClickHandlers(restProps)

  return (
    <Button.Contained
      className={className}
      text={t(text)}
      onClick={handleClickRestore}
    />
  )
}

export default RestoreButton
